import React from 'react'
import ReactRailsUJS from 'react_ujs'

import 'src/lib/react-host'

import './helpers/application'
import './helpers/admin'

import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'
import MainMenu from 'src/ui/MainMenu/MainMenu'
import LayoutBridge from 'src/ui/LayoutBridge'
import AlertTray from 'src/components/AlertTray'
import Banner from 'src/admin/components/Banner'
import Providers from 'src/config/Providers.js'
import BannerOfferCountdown from 'src/ui/Banner/BannerOfferCountdown/BannerOfferCountdown'
import LiveDate from 'src/components/LiveDate'

global.MainMenu = MainMenu
global.Banner = Banner
global.AlertTray = AlertTray
global.LayoutBridge = LayoutBridge
global.BannerOfferCountdown = BannerOfferCountdown
global.LiveDate = LiveDate

// Import everything under `routes/` and make it findable to the
// `react_component` view helper.
// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(require.context('src/routes', true))

// Modify the `react_component` component constructor to wrap our React components
// in our providers.
const originalConstructor = ReactRailsUJS.getConstructor
ReactRailsUJS.getConstructor = (className) => (props) => {
  return (
    <ErrorBoundary>
      <Providers version={2}>
        {React.createElement(originalConstructor(className), props)}
      </Providers>
    </ErrorBoundary>
  )
}
